import {
  FieldPolicy,
  FieldReadFunction,
  TypePolicies,
  TypePolicy,
} from "@apollo/client/cache";
export type AddressKeySpecifier = (
  | "country"
  | "createdAt"
  | "id"
  | "location"
  | "postcode"
  | "street"
  | "updatedAt"
  | AddressKeySpecifier
)[];
export type AddressFieldPolicy = {
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  location?: FieldPolicy<any> | FieldReadFunction<any>;
  postcode?: FieldPolicy<any> | FieldReadFunction<any>;
  street?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AvatarKeySpecifier = ("url" | AvatarKeySpecifier)[];
export type AvatarFieldPolicy = {
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BarchartItemKeySpecifier = (
  | "name"
  | "value"
  | BarchartItemKeySpecifier
)[];
export type BarchartItemFieldPolicy = {
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BillingInformationKeySpecifier = (
  | "accountNumber"
  | "address"
  | "createdAt"
  | "email"
  | "id"
  | "taxId"
  | "updatedAt"
  | BillingInformationKeySpecifier
)[];
export type BillingInformationFieldPolicy = {
  accountNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  address?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  taxId?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CalendarEventKeySpecifier = (
  | "allDay"
  | "id"
  | "scheduledFrom"
  | "scheduledTo"
  | "type"
  | CalendarEventKeySpecifier
)[];
export type CalendarEventFieldPolicy = {
  allDay?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  scheduledFrom?: FieldPolicy<any> | FieldReadFunction<any>;
  scheduledTo?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CanCreditsBeUsedKeySpecifier = (
  | "forCoaching"
  | "forTherapy"
  | CanCreditsBeUsedKeySpecifier
)[];
export type CanCreditsBeUsedFieldPolicy = {
  forCoaching?: FieldPolicy<any> | FieldReadFunction<any>;
  forTherapy?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CashTransactionKeySpecifier = (
  | "amount"
  | "createdAt"
  | "id"
  | "mollieTransaction"
  | "status"
  | "updatedAt"
  | CashTransactionKeySpecifier
)[];
export type CashTransactionFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  mollieTransaction?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChimeAttendeeInfoKeySpecifier = (
  | "AttendeeId"
  | "ExternalUserId"
  | "JoinToken"
  | ChimeAttendeeInfoKeySpecifier
)[];
export type ChimeAttendeeInfoFieldPolicy = {
  AttendeeId?: FieldPolicy<any> | FieldReadFunction<any>;
  ExternalUserId?: FieldPolicy<any> | FieldReadFunction<any>;
  JoinToken?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChimeMediaPlacementKeySpecifier = (
  | "AudioFallbackUrl"
  | "AudioHostUrl"
  | "ScreenDataUrl"
  | "ScreenSharingUrl"
  | "ScreenViewingUrl"
  | "SignalingUrl"
  | ChimeMediaPlacementKeySpecifier
)[];
export type ChimeMediaPlacementFieldPolicy = {
  AudioFallbackUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  AudioHostUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  ScreenDataUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  ScreenSharingUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  ScreenViewingUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  SignalingUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChimeMeetingInfoKeySpecifier = (
  | "ExternalMeetingId"
  | "MediaPlacement"
  | "MediaRegion"
  | "MeetingId"
  | ChimeMeetingInfoKeySpecifier
)[];
export type ChimeMeetingInfoFieldPolicy = {
  ExternalMeetingId?: FieldPolicy<any> | FieldReadFunction<any>;
  MediaPlacement?: FieldPolicy<any> | FieldReadFunction<any>;
  MediaRegion?: FieldPolicy<any> | FieldReadFunction<any>;
  MeetingId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ClientKeySpecifier = (
  | "createdAt"
  | "description"
  | "email"
  | "human"
  | "humanId"
  | "id"
  | "inviteToken"
  | "professional"
  | "professionalId"
  | "status"
  | "updatedAt"
  | ClientKeySpecifier
)[];
export type ClientFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  human?: FieldPolicy<any> | FieldReadFunction<any>;
  humanId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  inviteToken?: FieldPolicy<any> | FieldReadFunction<any>;
  professional?: FieldPolicy<any> | FieldReadFunction<any>;
  professionalId?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ClientEdgeKeySpecifier = (
  | "cursor"
  | "node"
  | ClientEdgeKeySpecifier
)[];
export type ClientEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ClientsConnectionKeySpecifier = (
  | "edges"
  | "pageInfo"
  | "totalCount"
  | ClientsConnectionKeySpecifier
)[];
export type ClientsConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConsultationKeySpecifier = (
  | "acceptedByHuman"
  | "acceptedByProfessional"
  | "bloomupFee"
  | "cashTransaction"
  | "createdAt"
  | "creditTransactions"
  | "duration"
  | "expectedReimbursementDate"
  | "fromMatching"
  | "human"
  | "humanId"
  | "id"
  | "isInstant"
  | "matchedHuman"
  | "message"
  | "professional"
  | "professionalFee"
  | "professionalId"
  | "requestedBy"
  | "scheduledFrom"
  | "scheduledTo"
  | "status"
  | "type"
  | "updatedAt"
  | "uuid"
  | ConsultationKeySpecifier
)[];
export type ConsultationFieldPolicy = {
  acceptedByHuman?: FieldPolicy<any> | FieldReadFunction<any>;
  acceptedByProfessional?: FieldPolicy<any> | FieldReadFunction<any>;
  bloomupFee?: FieldPolicy<any> | FieldReadFunction<any>;
  cashTransaction?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  creditTransactions?: FieldPolicy<any> | FieldReadFunction<any>;
  duration?: FieldPolicy<any> | FieldReadFunction<any>;
  expectedReimbursementDate?: FieldPolicy<any> | FieldReadFunction<any>;
  fromMatching?: FieldPolicy<any> | FieldReadFunction<any>;
  human?: FieldPolicy<any> | FieldReadFunction<any>;
  humanId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isInstant?: FieldPolicy<any> | FieldReadFunction<any>;
  matchedHuman?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  professional?: FieldPolicy<any> | FieldReadFunction<any>;
  professionalFee?: FieldPolicy<any> | FieldReadFunction<any>;
  professionalId?: FieldPolicy<any> | FieldReadFunction<any>;
  requestedBy?: FieldPolicy<any> | FieldReadFunction<any>;
  scheduledFrom?: FieldPolicy<any> | FieldReadFunction<any>;
  scheduledTo?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  uuid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConsultationEdgeKeySpecifier = (
  | "cursor"
  | "node"
  | ConsultationEdgeKeySpecifier
)[];
export type ConsultationEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConsultationsConnectionKeySpecifier = (
  | "edges"
  | "pageInfo"
  | "totalCount"
  | ConsultationsConnectionKeySpecifier
)[];
export type ConsultationsConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CountryKeySpecifier = (
  | "descriptionTranslationKey"
  | "id"
  | "imgUrl"
  | "regions"
  | "titleTranslationKey"
  | CountryKeySpecifier
)[];
export type CountryFieldPolicy = {
  descriptionTranslationKey?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  imgUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  regions?: FieldPolicy<any> | FieldReadFunction<any>;
  titleTranslationKey?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreditTransactionKeySpecifier = (
  | "amount"
  | "id"
  | CreditTransactionKeySpecifier
)[];
export type CreditTransactionFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DifferenceGaugeResultKeySpecifier = (
  | "averageFirstScore"
  | "averageImprovement"
  | "averageLatestScore"
  | DifferenceGaugeResultKeySpecifier
)[];
export type DifferenceGaugeResultFieldPolicy = {
  averageFirstScore?: FieldPolicy<any> | FieldReadFunction<any>;
  averageImprovement?: FieldPolicy<any> | FieldReadFunction<any>;
  averageLatestScore?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ExtendedPropsKeySpecifier = (
  | "status"
  | "type"
  | ExtendedPropsKeySpecifier
)[];
export type ExtendedPropsFieldPolicy = {
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FullCalendarEventKeySpecifier = (
  | "allDay"
  | "end"
  | "extendedProps"
  | "id"
  | "start"
  | "url"
  | FullCalendarEventKeySpecifier
)[];
export type FullCalendarEventFieldPolicy = {
  allDay?: FieldPolicy<any> | FieldReadFunction<any>;
  end?: FieldPolicy<any> | FieldReadFunction<any>;
  extendedProps?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  start?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FunnelItemKeySpecifier = (
  | "name"
  | "value"
  | FunnelItemKeySpecifier
)[];
export type FunnelItemFieldPolicy = {
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HumanKeySpecifier = (
  | "address"
  | "birthDate"
  | "canPayCoachingWithCredits"
  | "canPayConsultWithCredits"
  | "canPayWithCredits"
  | "contactForFeedback"
  | "country"
  | "createdAt"
  | "creditBalance"
  | "creditsLeft"
  | "deletedAt"
  | "email"
  | "firstName"
  | "id"
  | "lastName"
  | "mutuality"
  | "onboardedAt"
  | "organization"
  | "organizationId"
  | "password"
  | "phone"
  | "preferredLanguage"
  | "preferredProfessionalGender"
  | "region"
  | "timezone"
  | "updatedAt"
  | "user"
  | "uuid"
  | HumanKeySpecifier
)[];
export type HumanFieldPolicy = {
  address?: FieldPolicy<any> | FieldReadFunction<any>;
  birthDate?: FieldPolicy<any> | FieldReadFunction<any>;
  canPayCoachingWithCredits?: FieldPolicy<any> | FieldReadFunction<any>;
  canPayConsultWithCredits?: FieldPolicy<any> | FieldReadFunction<any>;
  canPayWithCredits?: FieldPolicy<any> | FieldReadFunction<any>;
  contactForFeedback?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  creditBalance?: FieldPolicy<any> | FieldReadFunction<any>;
  creditsLeft?: FieldPolicy<any> | FieldReadFunction<any>;
  deletedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  mutuality?: FieldPolicy<any> | FieldReadFunction<any>;
  onboardedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  organization?: FieldPolicy<any> | FieldReadFunction<any>;
  organizationId?: FieldPolicy<any> | FieldReadFunction<any>;
  password?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  preferredLanguage?: FieldPolicy<any> | FieldReadFunction<any>;
  preferredProfessionalGender?: FieldPolicy<any> | FieldReadFunction<any>;
  region?: FieldPolicy<any> | FieldReadFunction<any>;
  timezone?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  uuid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HumanCreditBalanceKeySpecifier = (
  | "remainingCoachingConsultations"
  | "remainingTherapyConsultations"
  | "total"
  | HumanCreditBalanceKeySpecifier
)[];
export type HumanCreditBalanceFieldPolicy = {
  remainingCoachingConsultations?: FieldPolicy<any> | FieldReadFunction<any>;
  remainingTherapyConsultations?: FieldPolicy<any> | FieldReadFunction<any>;
  total?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HumanWithTokensKeySpecifier = (
  | "accessToken"
  | "human"
  | "refreshToken"
  | HumanWithTokensKeySpecifier
)[];
export type HumanWithTokensFieldPolicy = {
  accessToken?: FieldPolicy<any> | FieldReadFunction<any>;
  human?: FieldPolicy<any> | FieldReadFunction<any>;
  refreshToken?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LineGraphItemKeySpecifier = (
  | "x"
  | "y"
  | LineGraphItemKeySpecifier
)[];
export type LineGraphItemFieldPolicy = {
  x?: FieldPolicy<any> | FieldReadFunction<any>;
  y?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LoginV2FailureResponseKeySpecifier = (
  | "reason"
  | LoginV2FailureResponseKeySpecifier
)[];
export type LoginV2FailureResponseFieldPolicy = {
  reason?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MatchedHumanKeySpecifier = (
  | "age"
  | "chosenProfessionalId"
  | "country"
  | "createdAt"
  | "human"
  | "id"
  | "matchConsultation"
  | "mutuality"
  | "mutualityOptions"
  | "noLocation"
  | "noMutuality"
  | "noSubtopic"
  | "noTopic"
  | "organization"
  | "preferredProfessionalGender"
  | "proposedMatches"
  | "region"
  | "subtopic"
  | "topic"
  | "treatment"
  | "treatmentOptions"
  | "updatedAt"
  | "userUuid"
  | "worries"
  | MatchedHumanKeySpecifier
)[];
export type MatchedHumanFieldPolicy = {
  age?: FieldPolicy<any> | FieldReadFunction<any>;
  chosenProfessionalId?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  human?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  matchConsultation?: FieldPolicy<any> | FieldReadFunction<any>;
  mutuality?: FieldPolicy<any> | FieldReadFunction<any>;
  mutualityOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  noLocation?: FieldPolicy<any> | FieldReadFunction<any>;
  noMutuality?: FieldPolicy<any> | FieldReadFunction<any>;
  noSubtopic?: FieldPolicy<any> | FieldReadFunction<any>;
  noTopic?: FieldPolicy<any> | FieldReadFunction<any>;
  organization?: FieldPolicy<any> | FieldReadFunction<any>;
  preferredProfessionalGender?: FieldPolicy<any> | FieldReadFunction<any>;
  proposedMatches?: FieldPolicy<any> | FieldReadFunction<any>;
  region?: FieldPolicy<any> | FieldReadFunction<any>;
  subtopic?: FieldPolicy<any> | FieldReadFunction<any>;
  topic?: FieldPolicy<any> | FieldReadFunction<any>;
  treatment?: FieldPolicy<any> | FieldReadFunction<any>;
  treatmentOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  userUuid?: FieldPolicy<any> | FieldReadFunction<any>;
  worries?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MessageKeySpecifier = (
  | "body"
  | "consultationId"
  | "createdAt"
  | "fromProfessional"
  | "id"
  | "updatedAt"
  | MessageKeySpecifier
)[];
export type MessageFieldPolicy = {
  body?: FieldPolicy<any> | FieldReadFunction<any>;
  consultationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  fromProfessional?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ModuleKeySpecifier = (
  | "id"
  | "title"
  | "url"
  | ModuleKeySpecifier
)[];
export type ModuleFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MultiLanguageStringKeySpecifier = (
  | "en"
  | "fr"
  | "nl"
  | MultiLanguageStringKeySpecifier
)[];
export type MultiLanguageStringFieldPolicy = {
  en?: FieldPolicy<any> | FieldReadFunction<any>;
  fr?: FieldPolicy<any> | FieldReadFunction<any>;
  nl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MutationKeySpecifier = (
  | "acceptInvite"
  | "answerQuestion"
  | "cancelConsultation"
  | "choosePasswordV2"
  | "completeHumanRegistration"
  | "confirmConsultation"
  | "copyCalendarEvents"
  | "createCalendarEvent"
  | "createConsultation"
  | "deleteCalendarEvents"
  | "enable2FA"
  | "inviteClient"
  | "joinOrganizationByEmailOrCodeV2"
  | "loginV2"
  | "loginWithSSO"
  | "payForConsultation"
  | "refreshAccessTokenV2"
  | "registerHumanV2"
  | "registerHumanWithInvite"
  | "registerProfessional"
  | "request2FASecrets"
  | "requestConsultationAsHuman"
  | "requestIntroAsHuman"
  | "requestReimbursement"
  | "rescheduleConsultation"
  | "resetPassword"
  | "setCurrentUserLanguage"
  | "startMatchingV2"
  | "startVideoCallV2"
  | "submitLocationStep"
  | "submitMutualityStep"
  | "submitSubtopicStep"
  | "submitTopicStep"
  | "submitTreatmentStep"
  | "toggleCoachingEnabledForProfessional"
  | "toggleTherapyEnabledForProfessional"
  | "updateCalendarEvent"
  | "updateConsultation"
  | "updateCurrentUser"
  | "updateHuman"
  | "updateHumanMutuality"
  | "updateMatchedHumanLanguage"
  | "updateProfessional"
  | "updateProfessionalRate"
  | "updateProfessionalSpecialties"
  | "updateProfessionalSubtopics"
  | "userJoinedConsultation"
  | "verifyProfessional"
  | MutationKeySpecifier
)[];
export type MutationFieldPolicy = {
  acceptInvite?: FieldPolicy<any> | FieldReadFunction<any>;
  answerQuestion?: FieldPolicy<any> | FieldReadFunction<any>;
  cancelConsultation?: FieldPolicy<any> | FieldReadFunction<any>;
  choosePasswordV2?: FieldPolicy<any> | FieldReadFunction<any>;
  completeHumanRegistration?: FieldPolicy<any> | FieldReadFunction<any>;
  confirmConsultation?: FieldPolicy<any> | FieldReadFunction<any>;
  copyCalendarEvents?: FieldPolicy<any> | FieldReadFunction<any>;
  createCalendarEvent?: FieldPolicy<any> | FieldReadFunction<any>;
  createConsultation?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteCalendarEvents?: FieldPolicy<any> | FieldReadFunction<any>;
  enable2FA?: FieldPolicy<any> | FieldReadFunction<any>;
  inviteClient?: FieldPolicy<any> | FieldReadFunction<any>;
  joinOrganizationByEmailOrCodeV2?: FieldPolicy<any> | FieldReadFunction<any>;
  loginV2?: FieldPolicy<any> | FieldReadFunction<any>;
  loginWithSSO?: FieldPolicy<any> | FieldReadFunction<any>;
  payForConsultation?: FieldPolicy<any> | FieldReadFunction<any>;
  refreshAccessTokenV2?: FieldPolicy<any> | FieldReadFunction<any>;
  registerHumanV2?: FieldPolicy<any> | FieldReadFunction<any>;
  registerHumanWithInvite?: FieldPolicy<any> | FieldReadFunction<any>;
  registerProfessional?: FieldPolicy<any> | FieldReadFunction<any>;
  request2FASecrets?: FieldPolicy<any> | FieldReadFunction<any>;
  requestConsultationAsHuman?: FieldPolicy<any> | FieldReadFunction<any>;
  requestIntroAsHuman?: FieldPolicy<any> | FieldReadFunction<any>;
  requestReimbursement?: FieldPolicy<any> | FieldReadFunction<any>;
  rescheduleConsultation?: FieldPolicy<any> | FieldReadFunction<any>;
  resetPassword?: FieldPolicy<any> | FieldReadFunction<any>;
  setCurrentUserLanguage?: FieldPolicy<any> | FieldReadFunction<any>;
  startMatchingV2?: FieldPolicy<any> | FieldReadFunction<any>;
  startVideoCallV2?: FieldPolicy<any> | FieldReadFunction<any>;
  submitLocationStep?: FieldPolicy<any> | FieldReadFunction<any>;
  submitMutualityStep?: FieldPolicy<any> | FieldReadFunction<any>;
  submitSubtopicStep?: FieldPolicy<any> | FieldReadFunction<any>;
  submitTopicStep?: FieldPolicy<any> | FieldReadFunction<any>;
  submitTreatmentStep?: FieldPolicy<any> | FieldReadFunction<any>;
  toggleCoachingEnabledForProfessional?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  toggleTherapyEnabledForProfessional?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  updateCalendarEvent?: FieldPolicy<any> | FieldReadFunction<any>;
  updateConsultation?: FieldPolicy<any> | FieldReadFunction<any>;
  updateCurrentUser?: FieldPolicy<any> | FieldReadFunction<any>;
  updateHuman?: FieldPolicy<any> | FieldReadFunction<any>;
  updateHumanMutuality?: FieldPolicy<any> | FieldReadFunction<any>;
  updateMatchedHumanLanguage?: FieldPolicy<any> | FieldReadFunction<any>;
  updateProfessional?: FieldPolicy<any> | FieldReadFunction<any>;
  updateProfessionalRate?: FieldPolicy<any> | FieldReadFunction<any>;
  updateProfessionalSpecialties?: FieldPolicy<any> | FieldReadFunction<any>;
  updateProfessionalSubtopics?: FieldPolicy<any> | FieldReadFunction<any>;
  userJoinedConsultation?: FieldPolicy<any> | FieldReadFunction<any>;
  verifyProfessional?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MutualitiesResponseKeySpecifier = (
  | "otherMutualities"
  | "regionMutualities"
  | MutualitiesResponseKeySpecifier
)[];
export type MutualitiesResponseFieldPolicy = {
  otherMutualities?: FieldPolicy<any> | FieldReadFunction<any>;
  regionMutualities?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MutualityKeySpecifier = (
  | "descriptionTranslationKey"
  | "id"
  | "imgUrl"
  | "linkUrlTranslationKey"
  | "preferred"
  | "title"
  | MutualityKeySpecifier
)[];
export type MutualityFieldPolicy = {
  descriptionTranslationKey?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  imgUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  linkUrlTranslationKey?: FieldPolicy<any> | FieldReadFunction<any>;
  preferred?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OrganizationKeySpecifier = (
  | "canCreditsBeUsed"
  | "coachingEnabled"
  | "coachingsPerHuman"
  | "code"
  | "color"
  | "consultsPerHuman"
  | "contractDashboardUrl"
  | "contractEndDate"
  | "contractStartDate"
  | "creditsPerCoaching"
  | "creditsPerConsult"
  | "creditsPerHuman"
  | "hasRenewalContract"
  | "id"
  | "interestDashboardUrl"
  | "logoUrl"
  | "mentalWellbeingDashboardUrl"
  | "mindlabBusinessId"
  | "mindlabEnabled"
  | "name"
  | "profile"
  | "slug"
  | "ssoEnabled"
  | "usageDashboardUrl"
  | "videoEnabled"
  | OrganizationKeySpecifier
)[];
export type OrganizationFieldPolicy = {
  canCreditsBeUsed?: FieldPolicy<any> | FieldReadFunction<any>;
  coachingEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  coachingsPerHuman?: FieldPolicy<any> | FieldReadFunction<any>;
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  color?: FieldPolicy<any> | FieldReadFunction<any>;
  consultsPerHuman?: FieldPolicy<any> | FieldReadFunction<any>;
  contractDashboardUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  contractEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  contractStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  creditsPerCoaching?: FieldPolicy<any> | FieldReadFunction<any>;
  creditsPerConsult?: FieldPolicy<any> | FieldReadFunction<any>;
  creditsPerHuman?: FieldPolicy<any> | FieldReadFunction<any>;
  hasRenewalContract?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  interestDashboardUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  logoUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  mentalWellbeingDashboardUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  mindlabBusinessId?: FieldPolicy<any> | FieldReadFunction<any>;
  mindlabEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  profile?: FieldPolicy<any> | FieldReadFunction<any>;
  slug?: FieldPolicy<any> | FieldReadFunction<any>;
  ssoEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  usageDashboardUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  videoEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PageInfoKeySpecifier = (
  | "endCursor"
  | "hasNextPage"
  | "hasPreviousPage"
  | "startCursor"
  | PageInfoKeySpecifier
)[];
export type PageInfoFieldPolicy = {
  endCursor?: FieldPolicy<any> | FieldReadFunction<any>;
  hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>;
  hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>;
  startCursor?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PracticeKeySpecifier = (
  | "address"
  | "chatTherapy"
  | "createdAt"
  | "id"
  | "offlineTherapy"
  | "onlineTherapy"
  | "phoneTherapy"
  | "updatedAt"
  | PracticeKeySpecifier
)[];
export type PracticeFieldPolicy = {
  address?: FieldPolicy<any> | FieldReadFunction<any>;
  chatTherapy?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  offlineTherapy?: FieldPolicy<any> | FieldReadFunction<any>;
  onlineTherapy?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneTherapy?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProfessionalKeySpecifier = (
  | "availability"
  | "availabilityV2"
  | "avatar"
  | "billingInformation"
  | "birthDate"
  | "clientStop"
  | "clients"
  | "cmNumber"
  | "coachingEnabled"
  | "coachingRate"
  | "consultationLanguages"
  | "createdAt"
  | "deletedAt"
  | "email"
  | "experienceSince"
  | "firstName"
  | "forBgt"
  | "gender"
  | "id"
  | "isFirstLine"
  | "isOnline"
  | "lastName"
  | "licenseFiles"
  | "onboardedAt"
  | "organizationId"
  | "phone"
  | "practice"
  | "preferredLanguage"
  | "primarySubtopics"
  | "profile"
  | "profileDescription"
  | "roleType"
  | "secondarySubtopics"
  | "specialties"
  | "standardRate"
  | "supervision"
  | "therapyEnabled"
  | "therapyTypes"
  | "timezone"
  | "training"
  | "type"
  | "updatedAt"
  | "user"
  | "uuid"
  | "verifiedAt"
  | "visumNumber"
  | "website"
  | ProfessionalKeySpecifier
)[];
export type ProfessionalFieldPolicy = {
  availability?: FieldPolicy<any> | FieldReadFunction<any>;
  availabilityV2?: FieldPolicy<any> | FieldReadFunction<any>;
  avatar?: FieldPolicy<any> | FieldReadFunction<any>;
  billingInformation?: FieldPolicy<any> | FieldReadFunction<any>;
  birthDate?: FieldPolicy<any> | FieldReadFunction<any>;
  clientStop?: FieldPolicy<any> | FieldReadFunction<any>;
  clients?: FieldPolicy<any> | FieldReadFunction<any>;
  cmNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  coachingEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  coachingRate?: FieldPolicy<any> | FieldReadFunction<any>;
  consultationLanguages?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  deletedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  experienceSince?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  forBgt?: FieldPolicy<any> | FieldReadFunction<any>;
  gender?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isFirstLine?: FieldPolicy<any> | FieldReadFunction<any>;
  isOnline?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  licenseFiles?: FieldPolicy<any> | FieldReadFunction<any>;
  onboardedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  organizationId?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  practice?: FieldPolicy<any> | FieldReadFunction<any>;
  preferredLanguage?: FieldPolicy<any> | FieldReadFunction<any>;
  primarySubtopics?: FieldPolicy<any> | FieldReadFunction<any>;
  profile?: FieldPolicy<any> | FieldReadFunction<any>;
  profileDescription?: FieldPolicy<any> | FieldReadFunction<any>;
  roleType?: FieldPolicy<any> | FieldReadFunction<any>;
  secondarySubtopics?: FieldPolicy<any> | FieldReadFunction<any>;
  specialties?: FieldPolicy<any> | FieldReadFunction<any>;
  standardRate?: FieldPolicy<any> | FieldReadFunction<any>;
  supervision?: FieldPolicy<any> | FieldReadFunction<any>;
  therapyEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  therapyTypes?: FieldPolicy<any> | FieldReadFunction<any>;
  timezone?: FieldPolicy<any> | FieldReadFunction<any>;
  training?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  uuid?: FieldPolicy<any> | FieldReadFunction<any>;
  verifiedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  visumNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  website?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProfessionalEdgeKeySpecifier = (
  | "cursor"
  | "node"
  | ProfessionalEdgeKeySpecifier
)[];
export type ProfessionalEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProfessionalHumanConnectionKeySpecifier = (
  | "edges"
  | ProfessionalHumanConnectionKeySpecifier
)[];
export type ProfessionalHumanConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProfessionalHumanEdgeKeySpecifier = (
  | "node"
  | ProfessionalHumanEdgeKeySpecifier
)[];
export type ProfessionalHumanEdgeFieldPolicy = {
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProfessionalsConnectionKeySpecifier = (
  | "edges"
  | "pageInfo"
  | "totalCount"
  | ProfessionalsConnectionKeySpecifier
)[];
export type ProfessionalsConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QueryKeySpecifier = (
  | "allConsultationsForHuman"
  | "allConsultationsForProfessional"
  | "calendarEvents"
  | "cashTransactionsByConsultationId"
  | "clientsForProfessional"
  | "consultation"
  | "consultationsForProfessionalAndHuman"
  | "countries"
  | "currentMatchedHuman"
  | "currentUser"
  | "getQuestionById"
  | "getSSOUrl"
  | "human"
  | "landingPageUniqueVisitors"
  | "lastCashTransactionByConsultationId"
  | "mindlabUser"
  | "mindlabUsers"
  | "mutualities"
  | "myProfessionalConsultations"
  | "organizationByEmailOrCode"
  | "organizationById"
  | "organizations"
  | "professional"
  | "professionalExists"
  | "professionals"
  | "professionalsForBgt"
  | "professionalsForCurrentHuman"
  | "professionalsV2"
  | "questionForUserAtEntryPoint"
  | "specialties"
  | "subtopics"
  | "topics"
  | "videoConsultBarchartEmployeesWithAnAmountOfConsults"
  | "videoConsultCardAverageConsultPerEmployee"
  | "videoConsultCardCancelledConsults"
  | "videoConsultCardCompletedConsults"
  | "videoConsultCardNoShowConsults"
  | "videoConsultFunnel"
  | "wellbeingChallenges"
  | "wellbeingEnergyGauge"
  | "wellbeingProductivityGauge"
  | "wellbeingStressGauge"
  | QueryKeySpecifier
)[];
export type QueryFieldPolicy = {
  allConsultationsForHuman?: FieldPolicy<any> | FieldReadFunction<any>;
  allConsultationsForProfessional?: FieldPolicy<any> | FieldReadFunction<any>;
  calendarEvents?: FieldPolicy<any> | FieldReadFunction<any>;
  cashTransactionsByConsultationId?: FieldPolicy<any> | FieldReadFunction<any>;
  clientsForProfessional?: FieldPolicy<any> | FieldReadFunction<any>;
  consultation?: FieldPolicy<any> | FieldReadFunction<any>;
  consultationsForProfessionalAndHuman?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  countries?: FieldPolicy<any> | FieldReadFunction<any>;
  currentMatchedHuman?: FieldPolicy<any> | FieldReadFunction<any>;
  currentUser?: FieldPolicy<any> | FieldReadFunction<any>;
  getQuestionById?: FieldPolicy<any> | FieldReadFunction<any>;
  getSSOUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  human?: FieldPolicy<any> | FieldReadFunction<any>;
  landingPageUniqueVisitors?: FieldPolicy<any> | FieldReadFunction<any>;
  lastCashTransactionByConsultationId?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  mindlabUser?: FieldPolicy<any> | FieldReadFunction<any>;
  mindlabUsers?: FieldPolicy<any> | FieldReadFunction<any>;
  mutualities?: FieldPolicy<any> | FieldReadFunction<any>;
  myProfessionalConsultations?: FieldPolicy<any> | FieldReadFunction<any>;
  organizationByEmailOrCode?: FieldPolicy<any> | FieldReadFunction<any>;
  organizationById?: FieldPolicy<any> | FieldReadFunction<any>;
  organizations?: FieldPolicy<any> | FieldReadFunction<any>;
  professional?: FieldPolicy<any> | FieldReadFunction<any>;
  professionalExists?: FieldPolicy<any> | FieldReadFunction<any>;
  professionals?: FieldPolicy<any> | FieldReadFunction<any>;
  professionalsForBgt?: FieldPolicy<any> | FieldReadFunction<any>;
  professionalsForCurrentHuman?: FieldPolicy<any> | FieldReadFunction<any>;
  professionalsV2?: FieldPolicy<any> | FieldReadFunction<any>;
  questionForUserAtEntryPoint?: FieldPolicy<any> | FieldReadFunction<any>;
  specialties?: FieldPolicy<any> | FieldReadFunction<any>;
  subtopics?: FieldPolicy<any> | FieldReadFunction<any>;
  topics?: FieldPolicy<any> | FieldReadFunction<any>;
  videoConsultBarchartEmployeesWithAnAmountOfConsults?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  videoConsultCardAverageConsultPerEmployee?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  videoConsultCardCancelledConsults?: FieldPolicy<any> | FieldReadFunction<any>;
  videoConsultCardCompletedConsults?: FieldPolicy<any> | FieldReadFunction<any>;
  videoConsultCardNoShowConsults?: FieldPolicy<any> | FieldReadFunction<any>;
  videoConsultFunnel?: FieldPolicy<any> | FieldReadFunction<any>;
  wellbeingChallenges?: FieldPolicy<any> | FieldReadFunction<any>;
  wellbeingEnergyGauge?: FieldPolicy<any> | FieldReadFunction<any>;
  wellbeingProductivityGauge?: FieldPolicy<any> | FieldReadFunction<any>;
  wellbeingStressGauge?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QuestionKeySpecifier = (
  | "category"
  | "component"
  | "id"
  | "nextQuestionId"
  | "options"
  | "questionType"
  | "title"
  | "translationKey"
  | QuestionKeySpecifier
)[];
export type QuestionFieldPolicy = {
  category?: FieldPolicy<any> | FieldReadFunction<any>;
  component?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  nextQuestionId?: FieldPolicy<any> | FieldReadFunction<any>;
  options?: FieldPolicy<any> | FieldReadFunction<any>;
  questionType?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  translationKey?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RegionKeySpecifier = (
  | "descriptionTranslationKey"
  | "id"
  | "imgUrl"
  | "titleTranslationKey"
  | RegionKeySpecifier
)[];
export type RegionFieldPolicy = {
  descriptionTranslationKey?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  imgUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  titleTranslationKey?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReimbursementKeySpecifier = (
  | "createdAt"
  | "id"
  | "reimbursementSubmission"
  | "updatedAt"
  | ReimbursementKeySpecifier
)[];
export type ReimbursementFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  reimbursementSubmission?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReimbursementSubmissionKeySpecifier = (
  | "createdAt"
  | "id"
  | "submittedAt"
  | "updatedAt"
  | ReimbursementSubmissionKeySpecifier
)[];
export type ReimbursementSubmissionFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  submittedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RestrictedClientKeySpecifier = (
  | "createdAt"
  | "description"
  | "email"
  | "human"
  | "humanId"
  | "id"
  | "professionalId"
  | "status"
  | RestrictedClientKeySpecifier
)[];
export type RestrictedClientFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  human?: FieldPolicy<any> | FieldReadFunction<any>;
  humanId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  professionalId?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type Secrets2FAKeySpecifier = (
  | "qrCode"
  | "secret"
  | Secrets2FAKeySpecifier
)[];
export type Secrets2FAFieldPolicy = {
  qrCode?: FieldPolicy<any> | FieldReadFunction<any>;
  secret?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SpecialtiesThemeComboKeySpecifier = (
  | "id"
  | "primaryColor"
  | "secondaryColor"
  | "subcategories"
  | "theme"
  | "tooltip"
  | "translationKey"
  | SpecialtiesThemeComboKeySpecifier
)[];
export type SpecialtiesThemeComboFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  primaryColor?: FieldPolicy<any> | FieldReadFunction<any>;
  secondaryColor?: FieldPolicy<any> | FieldReadFunction<any>;
  subcategories?: FieldPolicy<any> | FieldReadFunction<any>;
  theme?: FieldPolicy<any> | FieldReadFunction<any>;
  tooltip?: FieldPolicy<any> | FieldReadFunction<any>;
  translationKey?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SubCategoryKeySpecifier = (
  | "id"
  | "name"
  | "tooltip"
  | "translationKey"
  | SubCategoryKeySpecifier
)[];
export type SubCategoryFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  tooltip?: FieldPolicy<any> | FieldReadFunction<any>;
  translationKey?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SubmitMatchingStepResponseKeySpecifier = (
  | "matchedHuman"
  | "matchingToken"
  | "nextStep"
  | SubmitMatchingStepResponseKeySpecifier
)[];
export type SubmitMatchingStepResponseFieldPolicy = {
  matchedHuman?: FieldPolicy<any> | FieldReadFunction<any>;
  matchingToken?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStep?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SubtopicKeySpecifier = (
  | "descriptionTranslationKey"
  | "id"
  | "imageUrl"
  | "titleTranslationKey"
  | SubtopicKeySpecifier
)[];
export type SubtopicFieldPolicy = {
  descriptionTranslationKey?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  imageUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  titleTranslationKey?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TokenResponseKeySpecifier = (
  | "accessToken"
  | "mindlabToken"
  | "refreshToken"
  | TokenResponseKeySpecifier
)[];
export type TokenResponseFieldPolicy = {
  accessToken?: FieldPolicy<any> | FieldReadFunction<any>;
  mindlabToken?: FieldPolicy<any> | FieldReadFunction<any>;
  refreshToken?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TopicKeySpecifier = (
  | "descriptionTranslationKey"
  | "id"
  | "imageUrl"
  | "subtopics"
  | "titleTranslationKey"
  | TopicKeySpecifier
)[];
export type TopicFieldPolicy = {
  descriptionTranslationKey?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  imageUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  subtopics?: FieldPolicy<any> | FieldReadFunction<any>;
  titleTranslationKey?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TreatmentsResponseKeySpecifier = (
  | "availableTreatments"
  | "module"
  | "proposedTreatment"
  | TreatmentsResponseKeySpecifier
)[];
export type TreatmentsResponseFieldPolicy = {
  availableTreatments?: FieldPolicy<any> | FieldReadFunction<any>;
  module?: FieldPolicy<any> | FieldReadFunction<any>;
  proposedTreatment?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserKeySpecifier = (
  | "adminOfOrganization"
  | "birthDate"
  | "createdAt"
  | "email"
  | "firstName"
  | "human"
  | "id"
  | "lastName"
  | "mindlabNewsletter"
  | "mindlabUserId"
  | "onboardedAt"
  | "phone"
  | "preferredLanguage"
  | "professional"
  | "roleType"
  | "timezone"
  | "twoFactorAuthEnabled"
  | UserKeySpecifier
)[];
export type UserFieldPolicy = {
  adminOfOrganization?: FieldPolicy<any> | FieldReadFunction<any>;
  birthDate?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  human?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  mindlabNewsletter?: FieldPolicy<any> | FieldReadFunction<any>;
  mindlabUserId?: FieldPolicy<any> | FieldReadFunction<any>;
  onboardedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  preferredLanguage?: FieldPolicy<any> | FieldReadFunction<any>;
  professional?: FieldPolicy<any> | FieldReadFunction<any>;
  roleType?: FieldPolicy<any> | FieldReadFunction<any>;
  timezone?: FieldPolicy<any> | FieldReadFunction<any>;
  twoFactorAuthEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserFileKeySpecifier = (
  | "collectionName"
  | "fileName"
  | "id"
  | "mimeType"
  | "name"
  | "url"
  | UserFileKeySpecifier
)[];
export type UserFileFieldPolicy = {
  collectionName?: FieldPolicy<any> | FieldReadFunction<any>;
  fileName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  mimeType?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VideoCallV2KeySpecifier = (
  | "attendeeInfo"
  | "meetingInfo"
  | VideoCallV2KeySpecifier
)[];
export type VideoCallV2FieldPolicy = {
  attendeeInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  meetingInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WithDatesKeySpecifier = (
  | "createdAt"
  | "updatedAt"
  | WithDatesKeySpecifier
)[];
export type WithDatesFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WithIdKeySpecifier = ("id" | WithIdKeySpecifier)[];
export type WithIdFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type wellbeingChallengesResultKeySpecifier = (
  | "count"
  | "id"
  | "name"
  | wellbeingChallengesResultKeySpecifier
)[];
export type wellbeingChallengesResultFieldPolicy = {
  count?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StrictTypedTypePolicies = {
  Address?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | AddressKeySpecifier
      | (() => undefined | AddressKeySpecifier);
    fields?: AddressFieldPolicy;
  };
  Avatar?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | AvatarKeySpecifier
      | (() => undefined | AvatarKeySpecifier);
    fields?: AvatarFieldPolicy;
  };
  BarchartItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | BarchartItemKeySpecifier
      | (() => undefined | BarchartItemKeySpecifier);
    fields?: BarchartItemFieldPolicy;
  };
  BillingInformation?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | BillingInformationKeySpecifier
      | (() => undefined | BillingInformationKeySpecifier);
    fields?: BillingInformationFieldPolicy;
  };
  CalendarEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | CalendarEventKeySpecifier
      | (() => undefined | CalendarEventKeySpecifier);
    fields?: CalendarEventFieldPolicy;
  };
  CanCreditsBeUsed?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | CanCreditsBeUsedKeySpecifier
      | (() => undefined | CanCreditsBeUsedKeySpecifier);
    fields?: CanCreditsBeUsedFieldPolicy;
  };
  CashTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | CashTransactionKeySpecifier
      | (() => undefined | CashTransactionKeySpecifier);
    fields?: CashTransactionFieldPolicy;
  };
  ChimeAttendeeInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ChimeAttendeeInfoKeySpecifier
      | (() => undefined | ChimeAttendeeInfoKeySpecifier);
    fields?: ChimeAttendeeInfoFieldPolicy;
  };
  ChimeMediaPlacement?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ChimeMediaPlacementKeySpecifier
      | (() => undefined | ChimeMediaPlacementKeySpecifier);
    fields?: ChimeMediaPlacementFieldPolicy;
  };
  ChimeMeetingInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ChimeMeetingInfoKeySpecifier
      | (() => undefined | ChimeMeetingInfoKeySpecifier);
    fields?: ChimeMeetingInfoFieldPolicy;
  };
  Client?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ClientKeySpecifier
      | (() => undefined | ClientKeySpecifier);
    fields?: ClientFieldPolicy;
  };
  ClientEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ClientEdgeKeySpecifier
      | (() => undefined | ClientEdgeKeySpecifier);
    fields?: ClientEdgeFieldPolicy;
  };
  ClientsConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ClientsConnectionKeySpecifier
      | (() => undefined | ClientsConnectionKeySpecifier);
    fields?: ClientsConnectionFieldPolicy;
  };
  Consultation?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ConsultationKeySpecifier
      | (() => undefined | ConsultationKeySpecifier);
    fields?: ConsultationFieldPolicy;
  };
  ConsultationEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ConsultationEdgeKeySpecifier
      | (() => undefined | ConsultationEdgeKeySpecifier);
    fields?: ConsultationEdgeFieldPolicy;
  };
  ConsultationsConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ConsultationsConnectionKeySpecifier
      | (() => undefined | ConsultationsConnectionKeySpecifier);
    fields?: ConsultationsConnectionFieldPolicy;
  };
  Country?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | CountryKeySpecifier
      | (() => undefined | CountryKeySpecifier);
    fields?: CountryFieldPolicy;
  };
  CreditTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | CreditTransactionKeySpecifier
      | (() => undefined | CreditTransactionKeySpecifier);
    fields?: CreditTransactionFieldPolicy;
  };
  DifferenceGaugeResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | DifferenceGaugeResultKeySpecifier
      | (() => undefined | DifferenceGaugeResultKeySpecifier);
    fields?: DifferenceGaugeResultFieldPolicy;
  };
  ExtendedProps?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ExtendedPropsKeySpecifier
      | (() => undefined | ExtendedPropsKeySpecifier);
    fields?: ExtendedPropsFieldPolicy;
  };
  FullCalendarEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | FullCalendarEventKeySpecifier
      | (() => undefined | FullCalendarEventKeySpecifier);
    fields?: FullCalendarEventFieldPolicy;
  };
  FunnelItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | FunnelItemKeySpecifier
      | (() => undefined | FunnelItemKeySpecifier);
    fields?: FunnelItemFieldPolicy;
  };
  Human?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | HumanKeySpecifier
      | (() => undefined | HumanKeySpecifier);
    fields?: HumanFieldPolicy;
  };
  HumanCreditBalance?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | HumanCreditBalanceKeySpecifier
      | (() => undefined | HumanCreditBalanceKeySpecifier);
    fields?: HumanCreditBalanceFieldPolicy;
  };
  HumanWithTokens?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | HumanWithTokensKeySpecifier
      | (() => undefined | HumanWithTokensKeySpecifier);
    fields?: HumanWithTokensFieldPolicy;
  };
  LineGraphItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | LineGraphItemKeySpecifier
      | (() => undefined | LineGraphItemKeySpecifier);
    fields?: LineGraphItemFieldPolicy;
  };
  LoginV2FailureResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | LoginV2FailureResponseKeySpecifier
      | (() => undefined | LoginV2FailureResponseKeySpecifier);
    fields?: LoginV2FailureResponseFieldPolicy;
  };
  MatchedHuman?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | MatchedHumanKeySpecifier
      | (() => undefined | MatchedHumanKeySpecifier);
    fields?: MatchedHumanFieldPolicy;
  };
  Message?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | MessageKeySpecifier
      | (() => undefined | MessageKeySpecifier);
    fields?: MessageFieldPolicy;
  };
  Module?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ModuleKeySpecifier
      | (() => undefined | ModuleKeySpecifier);
    fields?: ModuleFieldPolicy;
  };
  MultiLanguageString?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | MultiLanguageStringKeySpecifier
      | (() => undefined | MultiLanguageStringKeySpecifier);
    fields?: MultiLanguageStringFieldPolicy;
  };
  Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | MutationKeySpecifier
      | (() => undefined | MutationKeySpecifier);
    fields?: MutationFieldPolicy;
  };
  MutualitiesResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | MutualitiesResponseKeySpecifier
      | (() => undefined | MutualitiesResponseKeySpecifier);
    fields?: MutualitiesResponseFieldPolicy;
  };
  Mutuality?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | MutualityKeySpecifier
      | (() => undefined | MutualityKeySpecifier);
    fields?: MutualityFieldPolicy;
  };
  Organization?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | OrganizationKeySpecifier
      | (() => undefined | OrganizationKeySpecifier);
    fields?: OrganizationFieldPolicy;
  };
  PageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | PageInfoKeySpecifier
      | (() => undefined | PageInfoKeySpecifier);
    fields?: PageInfoFieldPolicy;
  };
  Practice?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | PracticeKeySpecifier
      | (() => undefined | PracticeKeySpecifier);
    fields?: PracticeFieldPolicy;
  };
  Professional?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ProfessionalKeySpecifier
      | (() => undefined | ProfessionalKeySpecifier);
    fields?: ProfessionalFieldPolicy;
  };
  ProfessionalEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ProfessionalEdgeKeySpecifier
      | (() => undefined | ProfessionalEdgeKeySpecifier);
    fields?: ProfessionalEdgeFieldPolicy;
  };
  ProfessionalHumanConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ProfessionalHumanConnectionKeySpecifier
      | (() => undefined | ProfessionalHumanConnectionKeySpecifier);
    fields?: ProfessionalHumanConnectionFieldPolicy;
  };
  ProfessionalHumanEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ProfessionalHumanEdgeKeySpecifier
      | (() => undefined | ProfessionalHumanEdgeKeySpecifier);
    fields?: ProfessionalHumanEdgeFieldPolicy;
  };
  ProfessionalsConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ProfessionalsConnectionKeySpecifier
      | (() => undefined | ProfessionalsConnectionKeySpecifier);
    fields?: ProfessionalsConnectionFieldPolicy;
  };
  Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | QueryKeySpecifier
      | (() => undefined | QueryKeySpecifier);
    fields?: QueryFieldPolicy;
  };
  Question?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | QuestionKeySpecifier
      | (() => undefined | QuestionKeySpecifier);
    fields?: QuestionFieldPolicy;
  };
  Region?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | RegionKeySpecifier
      | (() => undefined | RegionKeySpecifier);
    fields?: RegionFieldPolicy;
  };
  Reimbursement?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ReimbursementKeySpecifier
      | (() => undefined | ReimbursementKeySpecifier);
    fields?: ReimbursementFieldPolicy;
  };
  ReimbursementSubmission?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ReimbursementSubmissionKeySpecifier
      | (() => undefined | ReimbursementSubmissionKeySpecifier);
    fields?: ReimbursementSubmissionFieldPolicy;
  };
  RestrictedClient?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | RestrictedClientKeySpecifier
      | (() => undefined | RestrictedClientKeySpecifier);
    fields?: RestrictedClientFieldPolicy;
  };
  Secrets2FA?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | Secrets2FAKeySpecifier
      | (() => undefined | Secrets2FAKeySpecifier);
    fields?: Secrets2FAFieldPolicy;
  };
  SpecialtiesThemeCombo?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | SpecialtiesThemeComboKeySpecifier
      | (() => undefined | SpecialtiesThemeComboKeySpecifier);
    fields?: SpecialtiesThemeComboFieldPolicy;
  };
  SubCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | SubCategoryKeySpecifier
      | (() => undefined | SubCategoryKeySpecifier);
    fields?: SubCategoryFieldPolicy;
  };
  SubmitMatchingStepResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | SubmitMatchingStepResponseKeySpecifier
      | (() => undefined | SubmitMatchingStepResponseKeySpecifier);
    fields?: SubmitMatchingStepResponseFieldPolicy;
  };
  Subtopic?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | SubtopicKeySpecifier
      | (() => undefined | SubtopicKeySpecifier);
    fields?: SubtopicFieldPolicy;
  };
  TokenResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | TokenResponseKeySpecifier
      | (() => undefined | TokenResponseKeySpecifier);
    fields?: TokenResponseFieldPolicy;
  };
  Topic?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | TopicKeySpecifier
      | (() => undefined | TopicKeySpecifier);
    fields?: TopicFieldPolicy;
  };
  TreatmentsResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | TreatmentsResponseKeySpecifier
      | (() => undefined | TreatmentsResponseKeySpecifier);
    fields?: TreatmentsResponseFieldPolicy;
  };
  User?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier);
    fields?: UserFieldPolicy;
  };
  UserFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | UserFileKeySpecifier
      | (() => undefined | UserFileKeySpecifier);
    fields?: UserFileFieldPolicy;
  };
  VideoCallV2?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | VideoCallV2KeySpecifier
      | (() => undefined | VideoCallV2KeySpecifier);
    fields?: VideoCallV2FieldPolicy;
  };
  WithDates?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | WithDatesKeySpecifier
      | (() => undefined | WithDatesKeySpecifier);
    fields?: WithDatesFieldPolicy;
  };
  WithId?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | WithIdKeySpecifier
      | (() => undefined | WithIdKeySpecifier);
    fields?: WithIdFieldPolicy;
  };
  wellbeingChallengesResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | wellbeingChallengesResultKeySpecifier
      | (() => undefined | wellbeingChallengesResultKeySpecifier);
    fields?: wellbeingChallengesResultFieldPolicy;
  };
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    CalendarFormats: ["CalendarEvent", "FullCalendarEvent"],
    ClientFormats: ["Client", "RestrictedClient"],
    LoginV2Response: ["LoginV2FailureResponse", "TokenResponse"],
    WithDates: [
      "Address",
      "BillingInformation",
      "Practice",
      "Reimbursement",
      "ReimbursementSubmission",
    ],
    WithId: [
      "Address",
      "BillingInformation",
      "Human",
      "Practice",
      "Professional",
      "Reimbursement",
      "ReimbursementSubmission",
    ],
  },
};
export default result;
